<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ $tc("sites.sites", 2) }}</h1>
                    </v-col>
                </v-row>
                <v-btn
                    color="secondary"
                    class="btn-add floating-btn"
                    elevation="0"
                    @click="$router.push({ name: 'sites_new' })"
                >
                    <v-icon size="18">mdi-plus</v-icon>
                    {{ $t("global.add") }}
                </v-btn>
            </div>

            <div class="wrap-datables">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="sites"
                            :items-per-page="25"
                            :search="search"
                        >

                            <template #[`item.actions`]="{ item }">
                                <v-btn
                                    class="edit ma-1"
                                    icon
                                    small
                                    dark
                                    @click="
                                        $router.push({
                                            name: 'sites_edit',
                                            params: { id: item.id },
                                        })
                                    "
                                >
                                    <v-icon size="16">mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-col>
</template>

<script>
export default {
    name: "Sites",
    data() {
        return {
            sites: [],
            search: "",
            headers: [
                {
                    text: this.$t("sites.designation"),
                    align: "start",
                    sortable: true,
                    value: "label",
                },
                {
                    text: this.$t("sites.code"),
                    align: "start",
                    sortable: true,
                    value: "code",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
        };
    },

    async mounted() {
        await this.$api.sites.all().then(({data: sites}) => this.sites = sites.data)
    },
};
</script>
